import React from 'react';
import { makeStyles } from '@material-ui/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles({
    textBox: {
        marginBottom: 100
    }
});

export default function Notes({ text, onTextChanged, ...rest }) {
    const classes = useStyles();
    return (
        <TextField
            fullWidth
            className={classes.textBox}
            multiline
            autoFocus
            label="Notes"
            placeholder="Enter notes..."
            rowsMax="4"
            value={text}
            onChange={e => onTextChanged(e.target.value)}
            {...rest}
        />
    );
}
